export const setMarkers = (markers) => {
  return {
    type: "SET_MARKERS",
    markers
  };
};